import TranslationText from '@Components/Utilities/TranslationText';

const ListPageBlogs = (props) => {
    return (
        props.blogs && props.blogs.length ?
            <div className='blog-seo no-print'>
                <h3>{props.BlogTitle}</h3>
                {props.blogs.map((blog, index) => (
                    <div className='blog-post'>
                        <a href={blog.Url} dangerouslySetInnerHTML={{ __html: blog.Title }} />
                        <em><TranslationText tKey='sandhills.dealerservices.boards.mvc.posted' /> {blog.DisplayDate}</em>
                    </div>
                ))}
            </div>
        : <></>
    )
};

export default ListPageBlogs;